import { render, staticRenderFns } from "./maid-detail.vue?vue&type=template&id=5a24669f"
import script from "./maid-detail.vue?vue&type=script&lang=js"
export * from "./maid-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports